export default class DtoLinkRule {
    constructor(obj) {
        this.idScenario = obj.idScenario // Option[Long],
        this.idRule = obj.idRule // Option[Long],
        this.active = obj.active // Option[Boolean],
        this.parameters = JSON.parse(obj.parameters || '{}') // Option[String],
    }
}